import ServiceAssignmentRulesEditComponent from './service_assignment_rules.edit.component';

let ServiceAssignmentRulesEditModule = angular.module('serviceAssignmentRulesEdit', [
])

.component('serviceAssignmentRulesEdit', ServiceAssignmentRulesEditComponent)

.name;

export default ServiceAssignmentRulesEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/edit/index.js